module.exports = __webpack_public_path__ + "static/media/icon_spinner_large.bdc71ac1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_spinner_large.svg
// module id = 80
// module chunks = 0